import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { SELECTION_CRITERIA_DICTIONARY } from '../../config/settings/constants'
import { getSelectionCriteria, savePurchaseOrder } from '../../services/purchaseOrder'
import { getLowestValueOffer } from '../../services/supplier'

export const ADD_SELECTED_OFFERS = 'ADD_SELECTED_OFFES'
export const onAddSelectedOffers = makeActionCreator(ADD_SELECTED_OFFERS, 'payload')

export const CLEAR_SELECTED_OFFERS = 'CLEAR_SELECTED_OFFERS'
export const onClearSelectedOffers = makeActionCreator(CLEAR_SELECTED_OFFERS)

export const CLOSE_SELECT_OFFER_DIALOG = 'CLOSE_SELECT_OFFER_DIALOG'
export const onCloseSelectOfferDialog = makeActionCreator(CLOSE_SELECT_OFFER_DIALOG, 'payload')

export const CREATE_PURCHARSE_ORDER = 'CREATE_PURCHARSE_ORDER'
export const onCreatePurcharseOrder = makeActionCreator(CREATE_PURCHARSE_ORDER, 'payload')

export const DELETE_SELECTED_OFFERS = 'DELETE_SELECTED_OFFERS'
export const onDeleteSelectedOffers = makeActionCreator(DELETE_SELECTED_OFFERS, 'payload')

export const DISABLE_LOWER_OFFER = 'DISABLE_LOWER_OFFER'
export const onDisableLowerOffer = makeActionCreator(DISABLE_LOWER_OFFER, 'payload')

export const DISABLE_OTHER_OFFER = 'DISABLE_OTHER_OFFER'
export const onDisableOtherOffer = makeActionCreator(DISABLE_OTHER_OFFER, 'payload')

export const DISABLE_OTHER_OFFER_TOTAL = 'DISABLE_OTHER_OFFER_TOTAL'
export const onDisableOtherOfferTotal = makeActionCreator(DISABLE_OTHER_OFFER_TOTAL, 'payload')

export const ENABLE_OTHER_OFFER = 'ENABLE_OTHER_OFFER'
export const onEnableOtherOffer = makeActionCreator(ENABLE_OTHER_OFFER, 'payload')

export const GET_SELECTION_CRITERIA = 'GET_SELECTION_CRITERIA'
export const GET_SELECTION_CRITERIA_SUCCESS = 'GET_SELECTION_CRITERIA_SUCCESS'
export const GET_SELECTION_CRITERIA_ERROR = 'GET_SELECTION_CRITERIA_ERROR'
export const onGetSelectionCriteria = makeActionCreator(GET_SELECTION_CRITERIA)
export const onGetSelectionCriteriaSuccess = makeActionCreator(GET_SELECTION_CRITERIA_SUCCESS, 'payload')
export const onGetSelectionCriteriaError = makeActionCreator(GET_SELECTION_CRITERIA_ERROR, 'payload')
export const onGetSelectionCriteriaThunk = () => async dispatch => {
  dispatch(onGetSelectionCriteria())

  const EXCLUDED_CRITERIA = [
    SELECTION_CRITERIA_DICTIONARY.LOWEST_OFFER,
    SELECTION_CRITERIA_DICTIONARY.TOTAL_LOWEST_OFFER
  ]

  try {
    const { data } = await getSelectionCriteria()
    const selectionCriteria = [...data.payload.criterioSeleccionVO]
      .map(criteria => ({
        value: String(criteria.id),
        label: criteria.nombreCriterio,
        order: criteria.orden
      }))
      .filter(criteria => !EXCLUDED_CRITERIA.includes(criteria.value))

    return dispatch(onGetSelectionCriteriaSuccess({ selectionCriteria }))
  } catch (error) {
    return dispatch(onGetSelectionCriteriaError({ error }))
  }
}

export const SAVE_PURCHASE_ORDER = 'SAVE_PURCHASE_ORDER'
export const SAVE_PURCHASE_ORDER_SUCCESS = 'SAVE_PURCHASE_ORDER_SUCCESS'
export const SAVE_PURCHASE_ORDER_ERROR = 'SAVE_PURCHASE_ORDER_ERROR'
export const onSavePurchaseOrder = makeActionCreator(SAVE_PURCHASE_ORDER)
export const onSavePurchaseOrderSuccess = makeActionCreator(SAVE_PURCHASE_ORDER_SUCCESS, 'payload')
export const onSavePurchaseOrderError = makeActionCreator(SAVE_PURCHASE_ORDER_ERROR, 'payload')
export const onSavePurchaseOrderThunk = payload => async dispatch => {
  dispatch(onSavePurchaseOrder())
  try {
    const { data } = await savePurchaseOrder(payload)

    batch(() => {
      dispatch(
        onSavePurchaseOrderSuccess({
          purchaseId:
            data?.payload?.ocInformation && data?.payload?.ocInformation.length > 0
              ? data?.payload?.ocInformation[0]?.porId
              : null,
          purchaseCode:
            data?.payload?.ocInformation && data?.payload?.ocInformation.length > 0
              ? data?.payload?.ocInformation[0]?.porCode
              : null,
          purchaseUrl: data?.payload?.resultUrl ?? null
        })
      )
      payload.callback()
    })
  } catch (error) {
    let errorModel = null

    if (error?.originalError?.response?.data?.errores) {
      errorModel = error?.originalError?.response?.data?.errores.map(error => ({
        code: error.codigo,
        description: error.descripcion
      }))
    }

    if (error?.originalError?.response?.data?.error) {
      errorModel = {
        code: error?.originalError?.response?.data?.status || '',
        description: error?.originalError?.response?.data?.error || ''
      }
    }

    batch(() => {
      dispatch(onSavePurchaseOrderError({ errors: errorModel }))
      payload.error()
    })
  }
}

export const LOWES_VALUE_OFFER = 'LOWES_VALUE_OFFER'
export const LOWES_VALUE_OFFER_SUCCESS = 'LOWES_VALUE_OFFER_SUCCESS'
export const LOWES_VALUE_OFFER__ERROR = 'LOWES_VALUE_OFFER__ERROR'
export const onLowesValueOffer = makeActionCreator(LOWES_VALUE_OFFER)
export const onLowesValueOfferSuccess = makeActionCreator(LOWES_VALUE_OFFER_SUCCESS, 'payload')
export const onLowesValueOfferError = makeActionCreator(LOWES_VALUE_OFFER__ERROR, 'payload')
export const onLowesValueOfferThunk = payload => async (dispatch, getState) => {
  dispatch(onLowesValueOffer())
  try {
    const { basicInfo } = getState().quoteBasicInformation
    const { data } = await getLowestValueOffer({ idCa: basicInfo.id, idOffer: payload.idOffer })

    dispatch(onLowesValueOfferSuccess())
    dispatch(onAddSelectedOffers({ offerId: payload.idOffer }))

    data.payload.menorSeleccionada && dispatch(onSelectLowestOffer())

    payload.callback()
  } catch (error) {
    const errors = error?.originalError?.response?.data?.errores.map(error => ({
      code: error.codigo,
      description: error.descripcion
    }))

    batch(() => {
      dispatch(onCloseSelectOfferDialog())
      dispatch(onSavePurchaseOrderError({ errors }))
      dispatch(onLowesValueOfferError())
    })
  }
}

export const SELECT_LOWEST_OFFER = 'SELECT_LOWEST_OFFER'
export const onSelectLowestOffer = makeActionCreator(SELECT_LOWEST_OFFER, 'payload')

export const SET_CRITERIA_PURCHASE_ORDER = 'SET_CRITERIA_PURCHASE_ORDER'
export const onSetCriteriaPurchaseOrder = makeActionCreator(SET_CRITERIA_PURCHASE_ORDER, 'payload')

export const SET_VALIDATION_INPUT_GROUP = 'SET_VALIDATION_INPUT_GROUP'
export const onSetValidationInputGroup = makeActionCreator(SET_VALIDATION_INPUT_GROUP, 'payload')

export const SHOW_SELECT_OFFER_DIALOG = 'SHOW_SELECT_OFFER_DIALOG'
export const onOpenSelectOfferDialog = makeActionCreator(SHOW_SELECT_OFFER_DIALOG, 'payload')

export const VALIDATION_INPUT_GROUP = 'VALIDATION_INPUT_GROUP'
export const onValidationInputGroup = makeActionCreator(VALIDATION_INPUT_GROUP, 'payload')
